const ClusterMarker = ({ count, onClick }) => {
    return (
        <button
            type="button"
            className="cluster-marker"
            aria-label={`Show ${count} map points`}
            onClick={onClick}>
            {count}
        </button>
    )
}

export default ClusterMarker
